export default __webpack_public_path__ + "static/media/logo-small.6c629749.png";